// JsFromRoutes CacheKey aab5f2ea6aa9700d539a1b90a4dd9ee7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  execute: /* #__PURE__ */ definePathHelper('put', '/projects/jobs/:id/execute'),
  toggle: /* #__PURE__ */ definePathHelper('put', '/projects/jobs/:id/toggle'),
  show: /* #__PURE__ */ definePathHelper('get', '/projects/jobs/:id/show'),
  runs: /* #__PURE__ */ definePathHelper('get', '/projects/jobs/:id/runs'),
}
